<template>
  <!-- 省市区联级 -->
  <div>
    <Cascader
      style="width: 100%"
      v-model:value="formState.regionValue"
      :options="options"
      placeholder="请选择..."
      @change="handelRegionValue"
      :load-data="loadData"
      change-on-select
      @blur="blurRegionValue"
    />
  </div>
</template>
<script >
import { Cascader } from 'ant-design-vue'
import axios from 'axios'
import { getProvince, getCity, getArea } from '@/api/terminalList.js'
export default {
  components: {
    Cascader
  },
  data() {
    return {
      options: [],
      cityCurrent: 0
    }
  },
  props: {
    formState: {
      type: Object,
      defaul: {
        regionValue: []
      }
    }
  },
  methods: {
    handelRegionValue() {
      //
    },
    blurRegionValue() {
      if (this.cityCurrent !== 1) {
        this.cityCurrent = 0
      }
    },
    //省市区懒加载
    loadData(selectedOptions) {
      let targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true // load options lazily
      let keepOption
      if (this.cityCurrent === 0) {
        axios.get(`/api/base/v1/areaselect/city/find?provinceCode=${targetOption.code}`).then((res) => {
          targetOption.loading = false
          let newOptions = res.data.data.map((item) => {
            return {
              ...item,
              value: item.name,
              label: item.name,
              isLeaf: false,
              level: item.level
            }
          })

          targetOption.children = newOptions
          this.options = [...this.options]
          keepOption = [...newOptions]
          this.cityCurrent = this.cityCurrent + 1
        })
      }
      if (this.cityCurrent === 1) {
        let flag = this.options.filter((i) => {
          return i.level == targetOption.level
        }).length
        if (flag) {
          this.cityCurrent = 0
          this.loadData(selectedOptions)
          return
        }
        axios.get(`/api/base/v1/areaselect/area/find?cityCode=${targetOption.code}`).then((res) => {
          targetOption.loading = false
          let newOptions = res.data.data.map((item) => {
            return {
              ...item,
              value: item.name,
              label: item.name,
              level: item.level,
              isLeaf: true
            }
          })
          targetOption.children = newOptions
          if (keepOption) {
            let areaFlag = keepOption.filter((i) => {
              return i.level == targetOption.level
            }).length

            if (areaFlag) {
              this.cityCurrent = 1
              this.loadData(selectedOptions)
              return
            } else {
              this.options = [...this.options]
              this.cityCurrent = 1
            }
          } else {
            this.options = [...this.options]
            this.cityCurrent = 1
          }
        })
      }
    },
    convertKey(arr, level) {
      level++
      arr.forEach((item) => {
        item.level = level
        if (item['childBrandList'].length != 0) {
          item.level = level
          this.convertKey(item.childBrandList, level)
        }
      })
      return arr
    },
    getFirstList() {
      getProvince().then((res) => {
        let newOptions = res.data.map((item) => {
          return {
            ...item,
            value: item.name,
            label: item.name,
            isLeaf: false
          }
        })
        if (this.formState.regionValue) {
          if (this.formState.regionValue.length == 0) {
            this.options = newOptions //容错赋值
          }
        }
        newOptions.forEach((elem) => {
          if (elem.name == this.formState.regionValue[0]) {
            getCity(elem.code).then((res1) => {
              elem.children = res1.data.map((item) => {
                return {
                  ...item,
                  value: item.name,
                  label: item.name,
                  isLeaf: false
                }
              })
              elem.children.forEach((element) => {
                if (element.name == this.formState.regionValue[1]) {
                  getArea(element.code).then((res2) => {
                    element.children = res2.data.map((item) => {
                      return {
                        ...item,
                        value: item.name,
                        label: item.name,
                        isLeaf: true
                      }
                    })
                    //最终赋值
                    this.options = newOptions
                  })
                }
              })
            })
          }
        })
      })
    }
  },
  mounted() {
    this.getFirstList()
  }
}
</script>
